import { Eyebrow, MaskLines } from "./Reveal";

const people = {
  sagan: { name: "Carl Sagan", img: "/img/thinkers/sagan.jpg" },
  feynman: { name: "Richard Feynman", img: "/img/thinkers/feynman.jpg" },
  hitchens: { name: "Christopher Hitchens", img: "/img/thinkers/hitchens.jpg" },
  dawkins: { name: "Richard Dawkins", img: "/img/thinkers/dawkins.jpg" },
};

const quotes = [
  { who: "sagan", text: "Extraordinary claims require extraordinary evidence.", source: "Cosmos, 1980" },
  { who: "feynman", text: "The first principle is that you must not fool yourself — and you are the easiest person to fool.", source: "Cargo Cult Science, 1974" },
  { who: "hitchens", text: "What can be asserted without evidence can also be dismissed without evidence.", source: "God Is Not Great, 2007" },
  { who: "dawkins", text: "Science is the poetry of reality.", source: "The Enemies of Reason, 2007" },
  { who: "sagan", text: "Science is a way of thinking much more than it is a body of knowledge.", source: "Interview, 1990" },
  { who: "feynman", text: "Science is the belief in the ignorance of experts.", source: "What Is Science?, 1966" },
  { who: "hitchens", text: "The essence of the independent mind lies not in what it thinks, but in how it thinks.", source: "Letters to a Young Contrarian, 2001" },
  { who: "dawkins", text: "We are going to die, and that makes us the lucky ones.", source: "Unweaving the Rainbow, 1998" },
];

const Card = ({ q, i }) => {
  const p = people[q.who];
  return (
    <figure
      data-testid={`thinker-quote-${i}`}
      className="group shrink-0 w-[82vw] sm:w-[520px] mr-4 sm:mr-6 flex gap-5 sm:gap-6 rounded-3xl border border-white/10 bg-panel p-5 sm:p-6 hover:border-lime/50 transition-colors duration-500"
    >
      <div className="relative shrink-0 w-20 h-24 sm:w-32 sm:h-40 rounded-2xl overflow-hidden">
        <img src={p.img} alt={p.name} loading="lazy" className="w-full h-full object-cover object-top grayscale contrast-125 group-hover:grayscale-0 group-hover:scale-105 transition-[filter,transform] duration-700" />
        <div className="absolute inset-0 ring-1 ring-inset ring-white/10 rounded-2xl" />
      </div>
      <div className="flex flex-col justify-between min-w-0">
        <blockquote className="font-serif text-lg sm:text-2xl leading-snug text-zinc-100">“{q.text}”</blockquote>
        <figcaption className="mt-4">
          <span className="block font-display font-bold text-white group-hover:text-lime transition-colors duration-300">{p.name}</span>
          <span className="block font-mono text-[12px] text-zinc-400 mt-0.5">{q.source}</span>
        </figcaption>
      </div>
    </figure>
  );
};

export const Thinkers = () => (
  <section data-testid="thinkers-section" className="py-24 sm:py-32 border-t border-white/10 overflow-hidden">
    <div className="px-5 sm:px-10 lg:px-16 mb-12">
      <Eyebrow className="mb-5">// Question everything</Eyebrow>
      <h2 className="font-display font-bold uppercase text-4xl sm:text-6xl lg:text-7xl leading-[0.9]">
        <MaskLines lines={["Voices of", <span className="text-lime">reason</span>]} />
      </h2>
    </div>
    <div className="thinkers-track relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-10 sm:w-24 bg-gradient-to-r from-ink to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-10 sm:w-24 bg-gradient-to-l from-ink to-transparent z-10" />
      <div className="flex w-max animate-thinkers">
        {[...quotes, ...quotes].map((q, i) => <Card key={i} q={q} i={i} />)}
      </div>
    </div>
    <p className="px-5 sm:px-10 lg:px-16 mt-8 text-[12px] text-zinc-400">
      Photos via Wikimedia Commons: Carl Sagan (NASA/JPL, public domain), Richard Feynman (public domain), Christopher Hitchens (Arkansas Lad, CC BY 2.0), Richard Dawkins (David Shankbone, CC BY 3.0).
    </p>
  </section>
);
